<template>
  <div class="m-edition-map-messages-list">
    <MoleculeEditionMapMessagesListSubMenu
      :loading="showLoadingState"
      :submenu-item="filter.tipo_comentario"
      :pending-messages="pendingMessages"
      @changeMessagesList="changeMessagesList"
    />
    <p
      v-if="showLoadingState"
      class="margin-top-xxlarge text-align-center"
    >
      Cargando datos...
    </p>
    <p
      v-if="!showLoadingState && !messages.length"
      class="margin-top-xxlarge text-align-center"
    >
      No hay mensajes pendientes.
    </p>
    <ul
      v-if="messages.length"
      class="m-edition-map-messages-list-items"
    >
      <li
        v-for="(msg, index) in messages"
        :key="index"
      >
        <a
          href="#"
          :class="msg.id === $store.getters.getAssetSelectedMessageInList.id ? 'selected-message' : ''"
          @click.prevent="goToMessage(msg)"
        >
          <span>
            <img
              class="a-avatar-primary"
              :src="msg.avatar"
            />
          </span>
          <span class="message-info">
            <span class="message-info-student">{{ msg.nombre }}</span>
            <span
              class="message-info-text"
              v-html="removeHtml(msg.mensaje)"
            >
            </span>
          </span>
          <span
            v-if="msg.tipo_comentario === 2"
            class="message-state message-state-pending"
          >
            <i class="far fa-question-circle"></i>
          </span>
        </a>
      </li>
    </ul>
    <MoleculePaginationSecondary
      v-if="!showLoadingState"
      :pagination="pagination"
      @setPaginationCurrentPage="setPaginationCurrentPage"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapMessagesList',

  components: {
    MoleculeEditionMapMessagesListSubMenu: () => import('@/components/molecules/MoleculeEditionMapMessagesListSubMenu'),
    MoleculePaginationSecondary: () => import('@/components/molecules/MoleculePaginationSecondary')
  },

  data () {
    return {
      filter: {
        tipo_comentario: 2,
        limite: 10,
        pagina: 1
      },

      messages: [],

      pagination: {
        currentPage: 1,
        limit: 10,
        showLoadingState: false,
        totalPages: 0
      },

      pendingMessages: 0,
      showLoadingState: false
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    'filter.pagina': {
      deep: true,

      handler () {
        this.messages = []
        this.showLoadingState = true
        this.$store.commit('setAssetSelectedMessageInList', {})
        this.readProyectoComentarios()
      }
    },

    updatedData () {
      if (Object.keys(this.$store.getters.getAssetSelectedMessageInList).length === 0 ||
        this.$store.getters.getAssetSelectedMessageInList.tipo_comentario === 2) {
        this.readProyectoComentarios()
      }
    }
  },

  created () {
    this.showLoadingState = true
    this.readProyectoComentarios()
  },

  methods: {
    changeMessagesList (item) {
      if (this.filter.tipo_comentario !== item) {
        this.filter.tipo_comentario = item
        if (this.filter.pagina === 1) {
          this.messages = []
          this.showLoadingState = true
          this.$store.commit('setAssetSelectedMessageInList', {})
          this.readProyectoComentarios()
        } else {
          this.setPaginationCurrentPage(1)
        }
      }
    },

    goToMessage (msg) {
      this.$store.commit('setAssetSelectedMessageInList', Object.assign({}, msg))
    },

    readProyectoComentarios () {
      this.$services.read('proyecto', 'readProyectoComentarios', {}, [this.$route.params.id], this.filter)
        .then(response => {
          console.log(response.data)
          this.messages = [...response.data.comentarios]
          this.pendingMessages = response.data.cant_preguntas
          this.$store.commit('setAssetSelectedMessageInList', Object.assign({}, this.messages[0]))
          this.pagination.totalPages = response.data.pages
          this.pagination.showLoadingState = false
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.pagination.totalPages = 0
          this.pagination.showLoadingState = false
          this.showLoadingState = false
        })
    },

    removeHtml (msg) {
      const regex = /(<([^>]+)>)/ig
      let cleanMessage = msg.replace(regex, '')
      return cleanMessage.length > 105
        ? cleanMessage.slice(0, 105) + '...'
        : cleanMessage
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
    }
  }
}
</script>
